export default __webpack_public_path__ + "9efe0e28ff54f468d7abf21c496f0730.png";